<template>
  <div class="new-auth-layout">
    <div class="main d-flex">
      <div class="col-lg-4 d-flex flex-column justify-content-between align-items-center">
        <div class="i-evollu-black mt-3 mb-3"></div>
        <div class="content">
          <slot name="main"></slot>
        </div>
        <div class="mb-5">
          <slot name="footer"></slot>
        </div>
      </div>
      <div class="d-none d-lg-flex col-lg-8 i-login-cover-3 flex-column justify-content-end align-items-center">
        <!--<span class="i-evollu-e-white"></span>-->
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'NewAuthLayout',
  props: {
    coverImage: {
      type: String,
      required: true
    }
  },
  components: {
  },
}
</script>

<style lang="scss">
.new-auth-layout {
  .i-evollu-black {
    //opacity: 0.2;
    height: 20px;
    width: 100%;
  }
  >.main {
    min-height: 100vh;
    background-color: #f5f5f5;
  }
}

</style>
